import { render, staticRenderFns } from "./Captains.vue?vue&type=template&id=5ed8ae30&scoped=true"
import script from "./Captains.vue?vue&type=script&lang=js"
export * from "./Captains.vue?vue&type=script&lang=js"
import style0 from "./Captains.vue?vue&type=style&index=0&id=5ed8ae30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed8ae30",
  null
  
)

export default component.exports